import { IMultiOccurrence, IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IFormulaire, IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IMonoOccurrence, IMonoOccurrenceOptions } from '../../../../../core/services/mono-occurrence.service';
import { IComponentController } from 'angular';
import { IMenuItemActionClass } from '../../../../../core/services/menu/menu-item-action.service';
import { IOperateurService } from '../../../../../core/services/operateur.service';
import { IPaginationClass } from '../../../../../core/services/pagination.service';

interface IPageAl2006 extends IComponentController {
    monoOccurrenceOptions: IMonoOccurrenceOptions;    
    monoOccurrence: IMonoOccurrence;
    formulaireDal: IFormulaire;
    dlxMultiOccurrence: IMultiOccurrence;
    dlxMultiOccurrenceOptions: IMultiOccurrenceOptions;
}

/* @ngInject */
export default function Al2006Controller(
    Formulaire: IFormulaireClass,
    Pagination: IPaginationClass,
    Operateur: IOperateurService,
    FormulaireItem: IFormulaireItemClass,
    MenuItemAction: IMenuItemActionClass
) {
    const vm: IPageAl2006 = this;

    vm.monoOccurrenceOptions = {
        fonctions: {
            afficherMenusDansEntete: true
        },
        menus: [
            new MenuItemAction(
                'LBL_BTN_SIMULER',
                'SIMULER',
                () => {
                    return {
                        demcleint: vm.monoOccurrence.data.demcleint,
                        dlpcleint: vm.monoOccurrence.data.dlpcleint
                    };
                },
                {
                    fonction: 'BOUSIM',
                    iconButton: false,
                    icon: '',
                    class: 'md-raised ex-button-action',
                    successAction: () => {
                        vm.dlxMultiOccurrence.fetchDataList();
                    }
                }
            )
        ]
    };

    vm.formulaireDal = new Formulaire([
        new FormulaireItem('demcleint', { largeur: 50 }),
        new FormulaireItem('dalcleint', { largeur: 50 }),
        new FormulaireItem('prfcleint', { largeur: 50 }),
        new FormulaireItem('dlpdatdebfin', { largeur: 50 })
    ]);

    vm.dlxMultiOccurrenceOptions = {
        bloc: 'dlx',
        fonctions: {
            nouveau: false,
            supprime: false,
            edition: false
        },
        criteresSuggeres: new Formulaire([
            new FormulaireItem('choix', { default: 'TOU', required: true }),                      
        ]),        
        pagination: new Pagination({
            nombreElementPage: 50,
            nbElementsPossibles: [50, 100, 150]
        }),
        colonnesFixesGauche: [{ nom: 'sttdatdeb', largeur: 110 }],        
        colonnesVisibles: [
            { nom: 'actcod', largeur: 120 },
            { nom: 'actdsc', largeur: 262 },
            { nom: 'stthredeb', largeur: 120 },
            { nom: 'stthrefin', largeur: 120 },
            { nom: 'sttqte', largeur: 90 },
            { nom: 'vaesttprv', largeur: 180 },
            { nom: 'aftcod', largeur: 180 },
            { nom: 'aftdsc', largeur: 262 },
            { nom: 'temcod', largeur: 180 },
            { nom: 'temdsc', largeur: 262 },
            { nom: 'lemcod', largeur: 190 },
            { nom: 'lemdsc', largeur: 262 },
            { nom: 'posnumdoc', largeur: 90 },
            { nom: 'postit', largeur: 262 },
            { nom: 'dernumdoc', largeur: 120 },
            { nom: 'derdsc', largeur: 262 },
            { nom: 'drpnumdoc', largeur: 200 },
            { nom: 'drpdsc', largeur: 262 },
            { nom: 'strcod', largeur: 190 },
            { nom: 'strdsc', largeur: 262 },
            { nom: 'unocod', largeur: 200 },
            { nom: 'unodscabr', largeur: 262 },
            { nom: 'imp', largeur: 262 }
        ],
        colonnesCachees: ['libelle_calendrier', 'ciecleint','stamnetab','tayflgabs', 'tayflgtra', 'sttdatfin', 'sttdatdeb', 'stthrefin', 'tstcleint', 'date_debut_fin']
    };
}
